import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/newsreader/opsz.css';
import '@fontsource-variable/newsreader/opsz-italic.css';
import '@fontsource-variable/hanken-grotesk/wght.css';
import App from './App';
import './styles/index.css';

function getApiBaseUrl() {
  return (import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '');
}

function reportFrontendError(payload) {
  const endpoint = `${getApiBaseUrl()}/meta/frontend-log`;
  const body = JSON.stringify(payload);

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(endpoint, blob);
      return;
    }
  } catch (_error) {
    // Fallback to fetch below.
  }

  fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {});
}

window.addEventListener('error', (event) => {
  reportFrontendError({
    type: 'window-error',
    message: event.message || 'Unhandled error',
    source: event.filename || '',
    url: window.location.href,
    stack: event.error?.stack || '',
    extra: {
      line: event.lineno || 0,
      column: event.colno || 0,
    },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  reportFrontendError({
    type: 'unhandled-rejection',
    message: event.reason?.message || String(event.reason || 'Promise rejection'),
    url: window.location.href,
    stack: event.reason?.stack || '',
    extra: null,
  });
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
